import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { fetchStoreMembersAPI } from '../../../redux/apis/store/members';

export const fetchStoreMembers = createAsyncThunk(
    'store/members',
    async ( {filters, storeId} , { rejectWithValue }) => {
        try {
            const res = await fetchStoreMembersAPI( storeId, filters);
            return res
        } catch(error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

//Create a slice
const storeMembersSlice = createSlice({
    name: 'storeMembers',
    initialState: {
        members: [],
        memberDetails: {},
        loading: false,
        error: null,
    },
    reducers: {
    // Define additional reducers here if needed

    },
    extraReducers: (builder) => {
        builder.addCase(fetchStoreMembers.fulfilled, (state,action) => {
            state.loading = false;
            state.members = action.payload;
            state.memberDetails = {}
            state.error = null;
        });

        builder.addCase(fetchStoreMembers.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(fetchStoreMembers.pending, (state) => {
            state.loading = true;
        })
    }
})

export const { /* Any additional actions */ } = storeMembersSlice.actions;

export default storeMembersSlice.reducer;